// «Моё здание» + «Также могу приезжать к ученику» (карта «Рядом с домом»).
//
// В базе ничего нового: address_mode остаётся 'building' (точный пин),
// районы выезда — в ту же колонку travel_districts, что у режима travel.
// Ограничения таблицы этого не запрещают (map_partners_no_point_offmap
// запрещает точку у travel/online, а не районы у building), и вид
// map_partners_public travel_districts уже отдаёт.
//
// Чистые помощники — их зовут и сервер (map-partners.functions.ts), и
// страницы (/tutors/join, /tutors), и проверка
// scripts/verify-map-building-travel.mts.
import { DISTRICTS, labelOf, type AddressMode, type PartnerKind } from "@/data/map-taxonomy";
import { DISTRICT_LABELS } from "@/lib/map-places";

/** Галочка — только у репетитора: у кружка выезда нет (map_partners_club_mode). */
export function canAlsoTravel(kind: PartnerKind, mode: AddressMode): boolean {
  return kind === "tutor" && mode === "building";
}

/**
 * Что пишется в travel_districts. travel — его районы, building с галочкой —
 * районы выезда, всё остальное (building без галочки, online, кружок) — пусто.
 */
export function travelDistrictsFor(input: { kind: PartnerKind; mode: AddressMode; alsoTravel: boolean; districts: string[] }): string[] {
  const { kind, mode, alsoTravel, districts } = input;
  if (mode === "travel") return [...new Set(districts)];
  if (alsoTravel && canAlsoTravel(kind, mode)) return [...new Set(districts)];
  return [];
}

/** Нужен хотя бы один район: у travel всегда, у building — если стоит галочка. */
export function travelDistrictsMissing(input: { kind: PartnerKind; mode: AddressMode; alsoTravel: boolean; districts: string[] }): boolean {
  return travelDistrictsFor(input).length === 0 && (input.mode === "travel" || (input.alsoTravel && canAlsoTravel(input.kind, input.mode)));
}

type Travelling = { address_mode: AddressMode; travel_districts: string[] };

/** Фильтр «Придёт к нам домой»: в районе выезда есть выбранный — и building с галочкой, и travel. */
export function comesHomeTo(p: Travelling, district: string): boolean {
  if (!district) return true;
  return p.address_mode !== "online" && p.travel_districts.includes(district);
}

/** Районы выезда у building — для строки «Также приезжает к ученику: …». Пусто — строки нет. */
export function alsoTravelsLine(p: Travelling, lang: "az" | "ru" | "en"): string {
  if (p.address_mode !== "building" || p.travel_districts.length === 0) return "";
  return p.travel_districts.map((d) => labelOf(DISTRICT_LABELS, d, lang)).join(", ");
}
